import FunctionalButton from "components/layout/FunctionalButton";
import { useTranslation } from "react-i18next";
import { useMap } from "providers/navigation/MapProvider";

const ToggleMapButton = ({ className = "", onClick }) => {
    const { t } = useTranslation("control");
    const { mapImageUrl, mapMetadata } = useMap();
    const hasMap = mapImageUrl && mapMetadata;

    return (
        <FunctionalButton
            className={`control-button-type3 ${hasMap ? "bg-primary2" : "bg-warning"} ${className}`}
            title={t("buttons.map")}
            hoverText={t("buttons.mapView")}
            disabled={false} // Always selectable
            onClick={onClick}
        />
    );
};

export default ToggleMapButton;
